import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const FamilyComposition: FC = () => {
  return (
    <Box mt={1}>
        <Header>
            <Box display={'flex'}>
                <Typography mb={1} ml={2}>Семейное отношение</Typography>
                <Typography mb={1} ml={30}>Фамилия, Имя, Отчество</Typography>
                <Typography mb={1} ml={30}>Дата рождения</Typography>
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
        </Header>
        <Body>
            <Box>
                <TextField
                    label="Фамилия"
                    variant="outlined"
                    size="small"
                    sx={{ width: "334px", mb: 1, mr: 1}}
                />                
                <TextField
                    label="Имя"
                    variant="outlined"
                    size="small"
                    sx={{ width: "333px", mb: 1, mr: 1}}
                />
                <TextField
                    label="Отчество"
                    variant="outlined"
                    size="small"
                    sx={{ width: "333px", mb: 1}}
                />
            </Box>
            <Box>
                <TextField
                    label="Семейное отношение"
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1}}
                />
                <TextField
                    label="Дата рождения"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, ml: 1 }}
                />
            </Box>
        </Body>

    </Box>
  );
};

export default FamilyComposition;
